"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ProxyManager = _interopRequireDefault(require("./ProxyManager.js"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var BaseAnalyticsManager = /*#__PURE__*/function () {
  function BaseAnalyticsManager(analyticsList, options) {
    (0, _classCallCheck2["default"])(this, BaseAnalyticsManager);

    if (!analyticsList || !analyticsList.length) {
      this.warn("Analytics not setup: please provide at least one analytics module");
    }

    this.analyticsList = analyticsList;

    if (options && options.proxy) {
      this.proxyManager = new _ProxyManager["default"]();
      this.enableProxy(options.proxy);
    }
  }

  (0, _createClass2["default"])(BaseAnalyticsManager, [{
    key: "enableProxy",
    value: function enableProxy(proxySettings) {
      var analyticsProxySettingsArray = this.analyticsList.map(function (analytics) {
        return analytics.getProxySettings();
      });
      this.proxyManager.enableProxy(proxySettings, analyticsProxySettingsArray);
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId) {
      this.userId = userId;
      this.analyticsList.forEach(function (analytics) {
        return analytics.setUserId(userId);
      });
    }
  }, {
    key: "getUserIds",
    value: function getUserIds() {
      return this.analyticsList.map(function (analytics) {
        return analytics.userId;
      });
    }
  }, {
    key: "enumerateInstalledModules",
    value: function () {
      var _enumerateInstalledModules = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(callback) {
        var results, _iterator, _step, analytics, res;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.userId) {
                  this.warn("Analytics not setup: call setUserId before calling any other methods.");
                }

                results = [];
                _iterator = _createForOfIteratorHelper(this.analyticsList);
                _context.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context.next = 20;
                  break;
                }

                analytics = _step.value;
                _context.prev = 7;
                _context.next = 10;
                return callback(analytics);

              case 10:
                res = _context.sent;
                results.push(res);
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](7);
                this.error(_context.t0);
                results.push(null);

              case 18:
                _context.next = 5;
                break;

              case 20:
                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t1 = _context["catch"](3);

                _iterator.e(_context.t1);

              case 25:
                _context.prev = 25;

                _iterator.f();

                return _context.finish(25);

              case 28:
                return _context.abrupt("return", results);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 22, 25, 28], [7, 14]]);
      }));

      function enumerateInstalledModules(_x) {
        return _enumerateInstalledModules.apply(this, arguments);
      }

      return enumerateInstalledModules;
    }()
  }, {
    key: "trackPageView",
    value: function () {
      var _trackPageView = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(props) {
        var promises, pageViewProps;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                promises = [];
                pageViewProps = this.getPageViewProps(props);
                _context3.next = 4;
                return this.enumerateInstalledModules( /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(analytics) {
                    var propLocal, promise;
                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            propLocal = Object.assign({}, pageViewProps);
                            promise = analytics.trackPageView(propLocal);
                            promises.push(promise);

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 4:
                return _context3.abrupt("return", Promise.all(promises));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function trackPageView(_x2) {
        return _trackPageView.apply(this, arguments);
      }

      return trackPageView;
    }()
  }, {
    key: "trackAppEntry",
    value: function () {
      var _trackAppEntry = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(userProps) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.enumerateInstalledModules( /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(analytics) {
                    return _regenerator["default"].wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (userProps) {
                              analytics.setUserPropsOnce(userProps);
                            }

                            _context4.next = 3;
                            return analytics.setCohortVisitParams();

                          case 3:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x5) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function trackAppEntry(_x4) {
        return _trackAppEntry.apply(this, arguments);
      }

      return trackAppEntry;
    }()
  }, {
    key: "getPageViewProps",
    value: function getPageViewProps() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var propsCopy = Object.assign({}, props);
      var title = propsCopy.title;
      var location = propsCopy.location;
      var path = propsCopy.path;
      delete propsCopy.title;
      delete propsCopy.location;
      delete propsCopy.path;
      return _objectSpread({
        page_title: title || document.title,
        page_location: location || window.location.href,
        page_path: path || window.location.pathname
      }, propsCopy);
    }
  }, {
    key: "setUserProps",
    value: function () {
      var _setUserProps = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(props) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.enumerateInstalledModules(function (analytics) {
                  return analytics.setUserProps(props);
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function setUserProps(_x6) {
        return _setUserProps.apply(this, arguments);
      }

      return setUserProps;
    }()
  }, {
    key: "setUserPropsOnce",
    value: function () {
      var _setUserPropsOnce = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(props) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.enumerateInstalledModules(function (analytics) {
                  return analytics.setUserPropsOnce(props);
                });

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setUserPropsOnce(_x7) {
        return _setUserPropsOnce.apply(this, arguments);
      }

      return setUserPropsOnce;
    }()
  }, {
    key: "setCohortVisitParams",
    value: function () {
      var _setCohortVisitParams = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.enumerateInstalledModules(function (analytics) {
                  return analytics.setCohortVisitParams();
                });

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setCohortVisitParams() {
        return _setCohortVisitParams.apply(this, arguments);
      }

      return setCohortVisitParams;
    }()
  }, {
    key: "trackCharge",
    value: function () {
      var _trackCharge = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(eventName, props) {
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.enumerateInstalledModules( /*#__PURE__*/function () {
                  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(analytics) {
                    var propLocal;
                    return _regenerator["default"].wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            propLocal = Object.assign({}, props);
                            return _context9.abrupt("return", analytics.trackCharge(eventName, propLocal));

                          case 2:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9);
                  }));

                  return function (_x10) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function trackCharge(_x8, _x9) {
        return _trackCharge.apply(this, arguments);
      }

      return trackCharge;
    }()
  }, {
    key: "incUserProps",
    value: function () {
      var _incUserProps = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(props) {
        var _this = this;

        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.enumerateInstalledModules( /*#__PURE__*/function () {
                  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(analytics) {
                    return _regenerator["default"].wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _context11.prev = 0;
                            return _context11.abrupt("return", analytics.incUserProps(props));

                          case 4:
                            _context11.prev = 4;
                            _context11.t0 = _context11["catch"](0);

                            _this.error(_context11.t0);

                          case 7:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, null, [[0, 4]]);
                  }));

                  return function (_x12) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function incUserProps(_x11) {
        return _incUserProps.apply(this, arguments);
      }

      return incUserProps;
    }()
  }, {
    key: "trackEvent",
    value: function trackEvent(eventName, props) {
      var _this2 = this;

      // we don't await track event since
      // they are sent in chunks every 10 seconds
      // which may significantly delay execution
      // instead if you want to wait, call 'await flush()'
      var _ = this.enumerateInstalledModules( /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(analytics) {
          var propLocal;
          return _regenerator["default"].wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  propLocal = Object.assign({}, props);
                  _context13.prev = 1;
                  return _context13.abrupt("return", analytics.trackEvent(eventName, propLocal));

                case 5:
                  _context13.prev = 5;
                  _context13.t0 = _context13["catch"](1);

                  _this2.error(_context13.t0);

                case 8:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, null, [[1, 5]]);
        }));

        return function (_x13) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "flush",
    value: function () {
      var _flush = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this.enumerateInstalledModules(function (analytics) {
                  return analytics.flush();
                }));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function flush() {
        return _flush.apply(this, arguments);
      }

      return flush;
    }()
  }, {
    key: "setDebug",
    value: function setDebug(isDebug) {
      this.debug = isDebug;
      return this.enumerateInstalledModules(function (analytics) {
        return analytics.setDebug(isDebug);
      });
    }
  }, {
    key: "log",
    value: function log() {
      if (this.debug) {
        var _console;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_console = console).log.apply(_console, ["analytics: "].concat(args));
      }
    }
  }, {
    key: "error",
    value: function error() {
      if (this.debug) {
        var _console2;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        (_console2 = console).error.apply(_console2, ["analytics: "].concat(args));
      }
    }
  }, {
    key: "warn",
    value: function warn() {
      if (this.debug) {
        var _console3;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        (_console3 = console).warn.apply(_console3, ["analytics: "].concat(args));
      }
    }
  }]);
  return BaseAnalyticsManager;
}();

exports["default"] = BaseAnalyticsManager;